export default __webpack_public_path__ + "static/Graphik-Light-Web-b2710133e8bd80ac9009d1c189b95118.ttf";